import { styled } from '@mui/material/styles'

export const StyledLogoWrapper = styled('div')`
  width: 26px;
  height: 26px;
  position: relative;
  overflow: hidden;
  display: inline-block;

  ${(props: { $circleView?: boolean; $logoWidth?: number; $logoHeight?: number }) => {
    let extraRules = ''
    if (props.$circleView) {
      extraRules += 'border-radius: 50%; '
    }
    if (props.$logoWidth) {
      extraRules += `min-width: ${props.$logoWidth}px;`
    }
    if (props.$logoHeight) {
      extraRules += `min-height: ${props.$logoHeight}px; `
    } else if (props.$logoWidth) {
      extraRules += `min-height: ${props.$logoWidth}px; `
    }

    return extraRules
  }};
`

export const StyledLogo = styled('img')`
  width: 100%;
  height: 100%;
`

export const StyledAltLogoWrapper = styled('span')`
  width: 100%;
  height: 100%;
  padding: 3px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  ${(props: { $circleView: boolean }) => (props.$circleView ? 'border-radius: 50%;' : '')}
  border-radius: 50%;
  justify-content: center;
  ${(props: { $background: string }) => (props.$background ? `background-color: ${props.$background};` : '')}
`
